export class Tags {
    public tags = [
        "Alpine",
        "BCA",
        "Bianco",
        "Barron",
        "GS",
        "MS",
        "JPM",
        "Lehman",
        "Salomon",
        "Citi",
        "Barclays",
        "DB",
        "BW",
        "BIS",
        "OECD",
        "SocGen",
        "BofA",
        "ML",
        "AQR",
        "BBG",
        "Morningstar",
        "State Street",
        "Vanguard",
        "NDR",
        "Pimco",
        "DoubleLine",
        "WSJ",
        "FT",
        "Fulcrum",
        "Gavekal",
        "GEM",
        "Harvard",
        "MKM",
        "TIFF",
        "Wolfe",
        "CS",

        "ARG",
        "AUS",

        "Asset Yield",
        "Asset Allocation",
        "Algo Trading",
        "Academic",
        "Balance of Payment",
        "Bank Credit Analyst",
        "BOE",
        "BOJ",
        "BOC",
        "Bond",
        "Book",
        "BRA",
        "Bond Risk Premium",
        "Brexit",
        "Bubble",
        "Business Investment",
        "BEL",
        "CAN",
        "Capex",
        "Capitalism",
        "CAPM",
        "Cash",
        "Central Bank",
        "CHE",
        "CHN",
        "Classic",
        "Coal",
        "Commodity",
        "Competitiveness",
        "Conflict",
        "Consensus",
        "Consumer Confidence",
        "Corporate",
        "Correlation",
        "Credit",
        "Credit Spread",
        "Crisis",
        "Cross-Border",
        "Cross Asset",
        "Currency Cap",
        "Confidential",
        "CZE",
        "Cycles",
        "Data",
        "Dates",
        "Debt Crisis",
        "Debt Cycle",
        "Deleveraging",
        "Derivatives",
        "DEU",
        "Diff",
        "Discount Rate",
        "Discounted Condition",
        "Diversification",
        "Digitized",
        "USD",
        "Downturn",
        "Driver",
        "DW",
        "Earning",
        "Early-Cycle",
        "Surprise",
        "Easing",
        "Endowment",
        "Eastern Europe",
        "Equity Risk Premium",
        "ECB",
        "ESG",
        "Economics",
        "Econometric",
        "Economic Condition",
        "EM",
        "EM Europe",
        "Environmental Bias",
        "Equity",
        "ESP",
        "EMU",
        "Expected Return",
        "External Position",
        "Excess",
        "Fair Value",
        "Fed",
        "Fiscal Policy",
        "Fixed Income",
        "FRA",
        "FX",
        "Geopolitics",
        "GBP",
        "GBR",
        "GDP",
        "GIS",
        "Gold",
        "Government Shutdown",
        "Growth",
        "Growth Tracking",
        "GRC",
        "Hedge Fund",
        "High Frequency",
        "History",
        "Household",
        "Housing",
        "HKG",
        "HUN",
        "IDN",
        "IND",
        "Indicator",
        "Inflation",
        "Inflation-Linked",
        "Intermarket",
        "Internal",
        "Index",
        "IRL",
        "ITA",
        "JPN",
        "KOR",
        "Labor",
        "Late-Cycle",
        "Latin America",
        "Linkage",
        "Liquidity",
        "Liquidity Cycle",
        "Long-Term",
        "Low Return",
        "Math",
        "Macro",
        "Macro Commentary",
        "Market Action",
        "MEX",
        "Mid-Cycle",
        "MMT",
        "Monetary Policy",
        "Money Market",
        "Model",
        "MP3",
        "MYS",
        "MBS",
        "Negative Interest Rate",
        "Normalization",
        "NOR",
        "NZL",
        "NLD",
        "Oil",
        "Outlook",
        "Pause",
        "Pension Fund",
        "Performance",
        "POL",
        "Policy Error",
        "Politics",
        "Populism",
        "Portfolio Construction",
        "Potential Growth",
        "Private Investment",
        "Private Equity",
        "Profit Margin",
        "Primer",
        "Probability",
        "PRT",
        "PHL",
        "QE",
        "Quant",
        "Rates",
        "Real Asset",
        "Real Estate",
        "Real Yield",
        "Recession",
        "Regime Change",
        "Rising Interest Rate",
        "Risk Curve",
        "Risk Parity",
        "Risk Premium",
        "Risk Management",
        "RUS",
        "Savings",
        "Secular",
        "Sentiment",
        "Short Rate",
        "Small Business",
        "Smart Beta",
        "Statistics",
        "Spread",
        "Supercycle",
        "SWE",
        "SGP",
        "Tariff",
        "Tail Risk",
        "Term Structure",
        "TAA",
        "SAA",
        "Technology",
        "Technical",
        "THA",
        "Tightening",
        "Trade",
        "Trade War",
        "Trading",
        "TUR",
        "TWN",
        "USA",
        "Valuation",
        "Volatility",
        "Viewpoint",
        "Wage",
        "War",
        "Wealth Effect",
        "WLD",
        "Yardeni",
        "Yield Curve",
        "Yield Curve Control",
        "ZAF",
        "Value Investing",

        "Weekly Reading",

        "Gilded",
        "Vault",
        "Special Collection",

        // special collections
        "Shelf",
        "ATW",
        "GRV"
    ];
}
